import { useEffect, useMemo, useState } from "react";
import { IoMdCloseCircle } from "react-icons/io";
import { getCompanyCustomers } from "../../services/clientCustomers.service";
import styles from "./css/clientCustomersModal.module.css";

export default function ClientCustomersModal({ show, companyId, onClose, formatDateTime }) {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const handleGetCustomers = async () => {
      try {
        if (!show || !companyId) return;

        setLoading(true);
        setError(null);
        setSearch("");

        const customersData = await getCompanyCustomers({ companyId });
        setCustomers(customersData);

      } catch (err) {
        console.error("ERROR - GET COMPANY CUSTOMERS FUNCTION:", err);
        setCustomers([]);
        setError("Nao foi possivel carregar os clientes no momento.");

      } finally {
        setLoading(false);
      }
    };

    handleGetCustomers();
  }, [show, companyId]);

  const filteredCustomers = useMemo(() => {
    if (!search.trim()) return customers;

    return customers.filter((item) =>
      String(item.name || "")
        .toLowerCase()
        .includes(search.trim().toLowerCase())
    );
  }, [customers, search]);

  if (!show) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContainer} onClick={(event) => event.stopPropagation()}>
        <header className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>Clientes cadastrados da empresa</h2>

          <button type="button" className={styles.closeButton} onClick={onClose}>
            <IoMdCloseCircle size={24} color="#2f3e49" />
          </button>
        </header>

        <div className={styles.modalBody}>
          <input
            type="text"
            className={styles.searchInput}
            value={search}
            onChange={(event) => setSearch(event.target.value)}
            placeholder="Buscar cliente por nome"
          />

          {loading ? (
            <p>Carregando clientes...</p>

          ) : error ? (
            <p>{error}</p>

          ) : filteredCustomers.length === 0 ? (
            <p>Nenhum cliente encontrado para o filtro informado.</p>

          ) : (
            <div className={styles.listArea}>
              {filteredCustomers.map((item) => (
                <article key={item.id} className={styles.listItem}>
                  <p><b>Nome:</b> {item.name}</p>
                  <p><b>Email:</b> {item.email}</p>
                  <p><b>Telefone:</b> {item.phone}</p>
                  <p><b>Documento:</b> {item.document}</p>
                  <p><b>Cadastro:</b> {formatDateTime(item.createdAt)}</p>
                </article>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
